import {LoadAsset} from './LoadAsset.class';
import {LoadAssetGroup} from './LoadAssetGroup.class';

export class StyleAssetGroup extends LoadAssetGroup {
  constructor(loadAssetList: LoadAsset[]) {
    super({type: 'Style', loadAssetList});
  }
}
